import { fetchAuthSession } from "aws-amplify/auth";
import { get } from "aws-amplify/api";
import { useQuery } from "react-query";

export const FOOD_JOURNAL_QUERY_KEY = "FOOD_JOURNAL_QUERY_KEY";
export const FOOD_JOURNAL_LATEST_QUERY_KEY = "FOOD_JOURNAL_LATEST_QUERY_KEY";


export const useFoodJournalLatestQuery = (patientUserId) => {
  return useQuery({
    queryKey: [FOOD_JOURNAL_LATEST_QUERY_KEY, patientUserId],
    retry: false,
    queryFn: latestFoodJournals.bind(this, patientUserId),
    staleTime: Infinity,
    placeholderData: {},
    enabled: !!patientUserId,
  });
};

const latestFoodJournals = async (patientUserId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "hifoodjournalapi",
    path: "/food-journals/latest/" + patientUserId,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};

export const useFoodJournalQuery = (patientUserId, foodJournalId) => {
  return useQuery({
    queryKey: [FOOD_JOURNAL_QUERY_KEY, foodJournalId],
    retry: false,
    queryFn: getFoodJournal.bind(this, patientUserId, foodJournalId),
    staleTime: Infinity,
    placeholderData: {},
    enabled: !!patientUserId && !!foodJournalId,
    select: (s) => {
      return {
        ...s,
        logDate: s.logDate?.replace(/-/g, "/") ?? "",
      };
    },
  });
};

const getFoodJournal = async (patientUserId, foodJournalId) => {
  const session = await fetchAuthSession();
  const { body } = await get({
    apiName: "hifoodjournalapi",
    path: `/food-journals//req/${patientUserId}/${foodJournalId}`,
    options: {
      headers: {
        Authorization: session.tokens.idToken.toString(),
      },
    },
  }).response;
  return await body.json();
};
